export const COMMON_SUGGEST_OFF_PROPERTY = 'off';
